import { Children, cloneElement, FormEvent } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';
import Spinner from 'onboarding/components/spinner/Spinner';

import { Button } from 'components/button/Button';

import { Check } from './Check';
import { TextArea } from './TextArea';

import s from './Form.module.scss';

const c = classNames.bind(s);

export type FormProps = {
  onSubmit?: (e: FormEvent<HTMLFormElement>) => void;
  children?: React.ReactNode;
  submitButtonText?: string;
  omitSubmitButton?: boolean;
  columns?: boolean;
  submitted?: boolean;
  loading?: boolean;
  errors?: boolean;
} & React.FormHTMLAttributes<HTMLFormElement>;

export const Form = ({
  onSubmit,
  children,
  submitButtonText,
  omitSubmitButton,
  columns,
  loading,
  errors,
  ...props
}: FormProps) => {
  const childArray = Children.toArray(children).filter(Boolean);

  if (!childArray.length && !onSubmit) {
    return null;
  }

  return (
    <form className={c(s.form, { columns })} onSubmit={onSubmit} noValidate {...props}>
      <div className={c(s.form__inner, { columns })}>
        {childArray.map((item) => {
          const component = item as React.ReactElement;
          const { type } = component;

          return cloneElement(component, {
            className: c(s.form__item, {
              span: type === TextArea || type === Check,
            }),
          });
        })}
        {onSubmit && loading && !errors && <Spinner />}
        {onSubmit && !omitSubmitButton && !loading && (
          <div className={s.form__actions}>
            <Button type="submit" icon="arrowright">
              {submitButtonText ?? (
                <FormattedMessage id="submit" defaultMessage="Senda" />
              )}
            </Button>
          </div>
        )}
      </div>
    </form>
  );
};
